import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, OnInit, signal, ViewChild } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { UserService } from './user.service';
import { CommonModule } from '@angular/common';
import { UserInfo } from './user-info/user-info';
import { NG_Modal } from './bootstrap/modal/modal';
import { NG_ModalService } from './bootstrap/modal/modalSvc.service';
import { NumericStringMap } from './models';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterOutlet, RouterLink, RouterLinkActive, FormsModule, CommonModule, UserInfo, NG_Modal],
	templateUrl: './app.component.html',
	styleUrl: './app.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class App implements OnInit, AfterViewInit {
	@ViewChild('NG_MODAL') modalComponent!: NG_Modal;
	protected readonly title = signal('tennant');
	menuOpen = false;
	public language : number = 2; //default to English

	public string_data = {
		MyWorkOrders: { 1: "My Work Orders", 2: "マイ作業指示" } as NumericStringMap,
		RequestWork: { 1: "Request Work", 2: "作業指示を依頼する" } as NumericStringMap,
		TenantPortal: { 1: "Tenant Portal", 2: "テナントポータル" } as NumericStringMap,
		AppTitle: { 1: "MCX Tenant Portal", 2: "MCXテナントポータル" } as NumericStringMap,
	}
	
	constructor(public userService: UserService, public router: Router, protected _cd: ChangeDetectorRef, protected modalSvc: NG_ModalService, private titleService: Title) {
		effect(() => {
			const tenant = this.userService.currentTennant();
			this.language = tenant ? tenant.Language : 2;
			// Update the page title based on language
			this.titleService.setTitle(this.string_data.AppTitle[this.language]);
			this._cd.detectChanges();
		});
	}

	ngAfterViewInit() {
		this.modalSvc.registerModal(this.modalComponent);
	}

	async ngOnInit() {
		//if the route is "/" or "/login", do nothing
		
		this.router.events.subscribe(async (event) => {
			// Only act on NavigationEnd events
			if (event.constructor.name === 'NavigationEnd') {
				if (this.router.url === '/' || this.router.url === '/login') {
					this.menuOpen = true;
					this._cd.detectChanges();
				}else{
					this.menuOpen = false;
					this._cd.detectChanges();
				}
				await this.runLoggedInCheck();
			}
		});
		/*
		let resp = await this.userService.checkLoggedIn();
		if (resp.success) {
			if (this.router.url === '/' || this.router.url === '/login') {
				this.router.navigate(['/my-work-orders']);
				this._cd.detectChanges();
			}
		} else {
			this.router.navigate(['/']);
		}
		*/
	}

	private async runLoggedInCheck() {
		let resp = await this.userService.checkLoggedIn();
		if (resp.success) {
			if (this.router.url === '/' || this.router.url === '/login') {
				this.router.navigate(['/home']);
				this._cd.detectChanges();
			}
		} else {
			//alert( 'Your session has expired. Please log in again.' );
			this.router.navigate(['/' ], {
				queryParams: this.router.parseUrl(this.router.url).queryParams
			});
		}

	}


}

/*
<div class="mobileMenuToggle" (click)="menuOpen = !menuOpen" style="text-align: right; color: #FFF; cursor: pointer; display: none;">
				<div *ngIf="!menuOpen"><i class="fa fa-bars" aria-hidden="true"></i> Menu</div>
			</div>
			*/